import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchWorkOrder} from 'sr/utils/api/fetchWorkOrder'
export const fetchWorkorderData = createAsyncThunk(
  'workorder/fetchWorkorderData',
  async (payload: any) => {
    // Single call instead of double-fetch pattern
    const response = await fetchWorkOrder({...payload, limit: 10000})
    const data: {workorder_name: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((workorder: any) => {
      idNameMap[workorder.id || workorder._id] = workorder.title
      data.push({
        workorder_name: workorder.title,
        id: workorder.id || workorder._id,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { workorder } = getState() as { workorder: { status: string } }
      return workorder.status !== 'succeeded' && workorder.status !== 'loading'
    },
  }
)
